// Supplier API integration boundary. Uses the shared, CSRF/auth-aware api client.
import { api } from "@/lib/api";

export const supplierService = {
  list: () => api.get("/suppliers").then((r) => r.data),
  create: (body) => api.post("/suppliers", body).then((r) => r.data),
  update: (id, body) => api.put(`/suppliers/${id}`, body).then((r) => r.data),
  remove: (id) => api.delete(`/suppliers/${id}`).then((r) => r.data),
};
